var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","fill-height":"","justify-center":""}},[_c('v-layout',{attrs:{"align-start":"","column":"","justify-center":"","wrap":""}},[(
        _vm.$store.state.hasOwnProperty('business') &&
        _vm.$store.state.business.hasOwnProperty('tools') &&
        _vm.$store.state.business.tools.hasOwnProperty('subscription') &&
        _vm.$store.state.business.tools.PBV.is_created
      )?_c('h2',{staticClass:"my-6 mr-0 ml-auto"},[_vm._v(" پرداخت با وندار ")]):_vm._e(),_c('v-flex',{staticStyle:{"width":"100%"}},[_c('setting')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }